
import City from "./Images/City.mp4";
import gold from "./Images/gold.png";
import Header from './Header';




export default function Background() {
  return (

    <div className="videodiv">
      <Header />


      <div className="divtextbackground">



        <div className="divtitle">

          <img className="imgback" src={gold}></img>
          <h1 className="titlebackground">Construir estruturas sólidas e relacionamentos duradouros! <hr className="hrbackground"></hr></h1>
         
          <h2 className="subbackground">Combinando <strong className="sbackground">inovação</strong>, <strong className="sbackground">sustentabilidade</strong> e <strong className="sbackground">compromisso</strong> para superar expectativas em cada projeto.</h2>
        </div>



      </div>



      <video
        className="video"
        controls={false}
        autoPlay={true}
        loop={true}
        playsInline={true}
        muted={true}
      >
        <source src={City} />
      </video>

    </div>

  );
}